/**
 * Accepts only same-origin app paths, so sign-in can never send anyone to another site.
 * Checks the normalised output: "/.//evil.example" normalises to "//evil.example".
 */
export function safeNext(value: unknown): string {
  if (typeof value !== "string" || value.length > 300 || !value.startsWith("/")) return "/";
  let url: URL;
  try {
    url = new URL(value, "https://app.invalid");
  } catch {
    return "/";
  }
  const next = `${url.pathname}${url.search}`;
  if (url.origin !== "https://app.invalid" || !next.startsWith("/") || next.startsWith("//") || next.includes("\\"))
    return "/";
  return next;
}
